import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "form_button"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_button = _resolveComponent("van-button");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_nav_bar, {
    title: "修改密码",
    "left-arrow": "",
    onClickLeft: $setup.goBack,
    fixed: "",
    placeholder: ""
  }, null, 8, ["onClickLeft"]), _createVNode(_component_van_cell_group, null, {
    default: _withCtx(() => [_createVNode(_component_van_field, {
      modelValue: $setup.formData.old_pwd,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.formData.old_pwd = $event),
      label: "旧密码",
      type: "password",
      placeholder: "请输入旧密码",
      required: ""
    }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
      modelValue: $setup.formData.user_pwd,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.formData.user_pwd = $event),
      label: "新密码",
      type: "password",
      placeholder: "请输入新密码",
      required: ""
    }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
      modelValue: $setup.formData.user_pwd2,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.formData.user_pwd2 = $event),
      label: "确认密码",
      type: "password",
      placeholder: "请输入确认",
      required: ""
    }, null, 8, ["modelValue"])]),
    _: 1
  }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_van_button, {
    type: "primary",
    round: "",
    block: "",
    onClick: $setup.saveInfo
  }, {
    default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("提交")])),
    _: 1
  }, 8, ["onClick"])])], 64);
}